.ch{border:1px solid #ddd;}